
import PropTypes from "prop-types";
import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { dateToString } from "components/Shared/Formatters";

const DatePickerField = props => {
  const value = props.input.value ? new Date(props.input.value) : null;
  
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        className={` ${props.containerClassName}`}
        onChange={(newValue) => props.input.onChange(dateToString(newValue))}
        value={value}
        slotProps={{
          textField: {
            variant: "standard",
            fullWidth: false,
          }
        }}
      />
    </LocalizationProvider>
  );
};

DatePickerField.propTypes = {
  input: PropTypes.object.isRequired,
  name: PropTypes.string,
  containerClassName: PropTypes.string
};
export default DatePickerField;